import Banner from "../../assets/images/dogbook/banner-register-p2.png";
import BannerRegister from "../../assets/images/dogbook/banner-register-p2-2.png";
import DogbookBanner from "../../assets/images/dogbook/dog-book-add-banner.png";
import DogbookAddBanner from "../../assets/images/dogbook/dog-book-add-banner.png";
import DogbookDiaryBanner from "../../assets/images/dogbook/dog-book-diary-banner.png";

import MemberCardOwner from "../../assets/images/membercardowner/banner-p2.png";

import CatbookBanner from "../../assets/images/catbook/banner-profile.png";
import CatRegisterBanner from "../../assets/images/catbook/banner-register-main.png";
import MyPointBannerCat from "../../assets/images/my-point/banner-cat-p2.png";
import CatbookDiaryBanner from "../../assets/images/catbook/cat-book-diary-banner.png";

import MyPointBanner from "../../assets/images/my-point/banner-p2.png";
import MyPointShopBanner from "../../assets/images/my-point-shop/banner-p2.png";
import redeemGiftBanner from "../../assets/images/redeem-gift/banner-member-p2.png";
import redeemGiftMemberBanner from "../../assets/images/redeem-gift/banner-member-p2.png";
import quiz from "../../assets/images/quiz4.png";
import inviteFriend from "../../assets/images/topbanner/invite-friend-p2.png";
import myPointStamp from "../../assets/images/topbanner/my-point-stamp.png";
import quizMania from "../../assets/images/topbanner/quiz-mania.png";
import quizManiaCat from "../../assets/images/topbanner/quiz-mania-cat.png";
import redeemGiftMemberBannerCat from "../../assets/images/redeem-gift/banner-member-cat-p2.png";
import React from "react";

export default function TopBanner({ type }) {
  let bannerImage;
  switch (type) {
    case 'dogbook':
      bannerImage = DogbookBanner;
      break;
    case 'dogbookDiary':
      bannerImage = DogbookDiaryBanner;
      break;
    case 'catbookDiary':
      bannerImage = CatbookDiaryBanner;
      break;
    case 'dogbookAdd':
      bannerImage = DogbookAddBanner;
      break;
    case 'register':
      bannerImage = BannerRegister;
      break
    case 'catbook':
      bannerImage = CatbookBanner;
      break
    case 'catRegister':
      bannerImage = CatRegisterBanner;
      break;
    case 'myPoint':
      bannerImage = MyPointBanner;
      break;
    case 'myPointCat':
      bannerImage = MyPointBannerCat;
      break;
    case 'memberCardOwner':
      bannerImage = MemberCardOwner;
      break;
    case 'redeemGift':
      bannerImage = redeemGiftBanner;
      break;
    case 'redeemGiftMember':
      bannerImage = redeemGiftMemberBanner;
      break;
    case 'redeemGiftMemberCat':
      bannerImage = redeemGiftMemberBannerCat;
      break;
    case 'myPointShop':
      bannerImage = MyPointShopBanner;
      break;
    case 'quiz':
      bannerImage = quiz;
      break;
    case 'inviteFriend':
      bannerImage = inviteFriend;
      break;
    case 'myPointStamp':
      bannerImage = myPointStamp;
      break;
    case 'quizMania':
      bannerImage = quizMania;
      break;
    case 'quizManiaCat':
      bannerImage = quizManiaCat;
      break;
    default:
      bannerImage = Banner;
  }
  return (
    <>
      <div className="text-center">
        <img
          src={bannerImage}
          alt="logo"
          className="w-full"
        />
      </div>
    </>
  );
}
